<template>
  <div>
    <!-- Header -->
    <div class="relative flex justify-center items-center">
      <div class="absolute z-30 text-white px-6">
        <h1 class="text-4xl md:text-5xl leading-[50px] md:leading-[60px] font-serif text-center">{{
          $t('events.our-events') }}</h1>
      </div>
      <div class="absolute z-20 inset-0 bg-black opacity-40"></div>

      <ClientOnly>
        <swiper-container ref="containerRef" :init="false" class="w-full">
          <swiper-slide v-for="index in imageCount" :key="index">
            <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw"
              class="object-cover min-h-[400px] w-full md:aspect-[3]" :src="`/images/events/event_1/${index}.jpg`" />
          </swiper-slide>
        </swiper-container>
      </ClientOnly>
    </div>

    <div class="container mx-auto px-6 py-12 md:p-20">
      <p class="text-base text-gray-600 pb-12 md:pb-20">
        {{ $t('events.upcoming-events-message') }}
      </p>
      <div class="grid grid-cols-1 gap-20">
        <NuxtLink v-for="event in events" :key="event.id" :to="`/events/${event.id}`">
          <div class="bg-white rounded-lg shadow-md overflow-hidden flex flex-col xl:flex-row">
            <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" :src="`/images/events/${event.id}.jpg`"
              :alt="event.name" class="object-cover w-full xl:w-1/2" />
            <div class="p-6 xl:w-1/2 border flex flex-col gap-4 justify-center">
              <div>
                <h2 class="text-lg md:text-xl font-semibold font-serif">{{ $t('events.' + event.id + '.title') }}</h2>
                <span v-if="$te('events.' + event.id + '.subtitle')" class="md:text-base font-semibold font-serif block text-gray-600 my-2">{{ $t('events.' + event.id
                  + '.subtitle') }}</span>
              </div>
              <div class="flex gap-4 flex-wrap">
                <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit whitespace-nowrap"
                  :class="{
                    'bg-blue-500': event.target === 'adults',
                    'bg-green-500': event.target === 'children',
                    'bg-purple-500': event.target === 'teens',
                    'bg-teal-500': event.target === 'youth',
                    'bg-indigo-500': event.target === 'elderly',
                    'bg-pink-500': event.target === 'fragile'
                  }">{{
                    $t('events.targets.' + event.target) }}</span>
                <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit bg-[#28a745] whitespace-nowrap">{{
                  $t('events.free') }}</span>
                <span class="text-sm text-white px-2 py-1 rounded-full max-w-fit bg-[#ff9800] whitespace-nowrap">{{
                  $t('events.reservation_required') }}</span>
              </div>
              <span class="text-sm md:text-base text-gray-600 flex items-center">
                <Icon name="mdi:map-marker-outline" class="mr-2" />{{ $t('events.' + event.id + '.location') }}
              </span>
              <div class="flex gap-4 flex-col lg:flex-row">
                <div v-for="(date, index) in $tm('events.' + event.id + '.dates')" :key="index">
                  <p class="text-xs md:text-sm text-gray-700 bg-gray-200 py-2 px-4 rounded-lg inline-block">
                    {{ date }}
                  </p>
                </div>
              </div>
              <p class="text-sm md:text-base text-gray-600 ">{{ $t('events.' + event.id + '.short-description') }}
              </p>
              <NuxtLink :to="localePath(`/events/${event.id}`)" class="mt-4 text-blue-500 hover:text-blue-700">
                <Button class="bg-tau-red w-full">
                  <div>{{ $t('home.events.learn-more') }}</div>
                </Button>
              </NuxtLink>
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEventStore } from '~/stores/event'; // Adjust the path if necessary
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const eventStore = useEventStore();
const events = computed(() => {
  return [...eventStore.events]
    .filter(e => !e.hide)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
});


const imageCount = 8;
const containerRef = ref(null);

const swiper = useSwiper(containerRef, {
  loop: true,
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {},
});

</script>

<style>
/* Add any specific styles for the events page here */
</style>